var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagemLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "imagem-login",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 777.703,
    height: 518.877,
    viewBox: "0 0 777.703 518.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_39",
    "data-name": "Ret\\xE2ngulo 39",
    width: 777.703,
    height: 518.877,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_38",
    "data-name": "Ret\\xE2ngulo 38",
    width: 777.702,
    height: 518.877,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_13",
    "data-name": "Ret\\xE2ngulo 13",
    width: 41.499,
    height: 11.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_14",
    "data-name": "Ret\\xE2ngulo 14",
    width: 41.499,
    height: 11.659,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15",
    "data-name": "Ret\\xE2ngulo 15",
    width: 41.499,
    height: 11.66,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16",
    "data-name": "Ret\\xE2ngulo 16",
    width: 89.391,
    height: 11.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17",
    "data-name": "Ret\\xE2ngulo 17",
    width: 39.812,
    height: 11.659,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_18",
    "data-name": "Ret\\xE2ngulo 18",
    width: 59.665,
    height: 11.66,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_19",
    "data-name": "Ret\\xE2ngulo 19",
    width: 41.499,
    height: 11.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_20",
    "data-name": "Ret\\xE2ngulo 20",
    width: 129.149,
    height: 11.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_21",
    "data-name": "Ret\\xE2ngulo 21",
    width: 77.395,
    height: 11.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_22",
    "data-name": "Ret\\xE2ngulo 22",
    width: 117.972,
    height: 11.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_23",
    "data-name": "Ret\\xE2ngulo 23",
    width: 108.975,
    height: 11.659,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_24",
    "data-name": "Ret\\xE2ngulo 24",
    width: 114.258,
    height: 11.66,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_27",
    "data-name": "Ret\\xE2ngulo 27",
    width: 129.146,
    height: 11.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_28",
    "data-name": "Ret\\xE2ngulo 28",
    width: 59.665,
    height: 11.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_30",
    "data-name": "Ret\\xE2ngulo 30",
    width: 114.258,
    height: 11.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_31",
    "data-name": "Ret\\xE2ngulo 31",
    width: 55.077,
    height: 14.066,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_32",
    "data-name": "Ret\\xE2ngulo 32",
    width: 14.055,
    height: 14.066,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_34",
    "data-name": "Ret\\xE2ngulo 34",
    width: 14.058,
    height: 14.066,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_37",
    "data-name": "Ret\\xE2ngulo 37",
    width: 42.454,
    height: 42.417,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_168",
    "data-name": "Grupo 168",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M1932.895,964.895v142.379l228.874.177.153-284.935H1932.895Z",
    transform: "translate(-1384.843 -589.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167",
    "data-name": "Grupo 167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_166",
    "data-name": "Grupo 166",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M1983.747,1509.495h0l-52.432-.037a.624.624,0,0,1-.624-.625V1383.408a.625.625,0,1,1,1.249,0v124.8l51.808.036a.625.625,0,0,1,0,1.249",
    transform: "translate(-1383.264 -990.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M2272.311,1106.6h0l-47.772-.019a.625.625,0,0,1,0-1.249l47.148.018V821.562H2087.6a.625.625,0,1,1,0-1.249h184.714a.624.624,0,0,1,.625.625v285.037a.625.625,0,0,1-.625.625",
    transform: "translate(-1495.234 -587.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M1140.662,1499.339h10.52a9.541,9.541,0,1,1,0,19.083H971.143a9.541,9.541,0,1,1,0-19.083h169.52Z",
    transform: "translate(-688.942 -1074.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M1006.892,1304.235h4.429c1.381,11.182-5.621,17.178-12.555,17.178H629.4c-6.934,0-13.65-5.4-12.555-17.178h390.043Z",
    transform: "translate(-441.864 -934.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M1011.619,708.957H617.147v-221a14.584,14.584,0,0,1,14.584-14.584h365.3a14.584,14.584,0,0,1,14.584,14.584Z",
    transform: "translate(-442.162 -339.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M1010.042,708H615.57a.625.625,0,0,1-.625-.625v-221a15.225,15.225,0,0,1,15.208-15.208h365.3a15.225,15.225,0,0,1,15.208,15.208v221a.625.625,0,0,1-.625.625m-393.847-1.249h393.223V486.382a13.975,13.975,0,0,0-13.959-13.959h-365.3a13.975,13.975,0,0,0-13.959,13.959Z",
    transform: "translate(-440.584 -337.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M664.667,729.555V522.414a1.459,1.459,0,0,1,1.459-1.459h364.607a1.459,1.459,0,0,1,1.459,1.459V729.555Z",
    transform: "translate(-476.208 -373.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M1030.614,728.6H663.089a.624.624,0,0,1-.625-.625V520.837a2.085,2.085,0,0,1,2.084-2.084h364.606a2.086,2.086,0,0,1,2.084,2.084V727.978a.624.624,0,0,1-.624.625m-366.9-1.249h366.276V520.837a.836.836,0,0,0-.835-.835H664.548a.836.836,0,0,0-.834.835Z",
    transform: "translate(-474.629 -371.666)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_12",
    "data-name": "Ret\\xE2ngulo 12",
    width: 144.008,
    height: 38.165,
    transform: "translate(300.217 386.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M1201.25,1402.031H1057.241a.624.624,0,0,1-.625-.625v-38.164a.625.625,0,1,1,1.249,0v37.54h142.76v-37.54a.625.625,0,0,1,1.249,0v38.164a.624.624,0,0,1-.625.625",
    transform: "translate(-757.024 -976.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M997.487,1332.1H628.125a13.2,13.2,0,0,1-13.179-13.2.625.625,0,0,1,1.249,0,11.952,11.952,0,0,0,11.93,11.947H997.487a11.952,11.952,0,0,0,11.931-11.947.625.625,0,0,1,1.249,0,13.2,13.2,0,0,1-13.18,13.2",
    transform: "translate(-440.585 -944.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M1149.6,1517.467H969.564a10.166,10.166,0,1,1,0-20.332h9.681a.625.625,0,0,1,0,1.249h-9.681a8.917,8.917,0,1,0,0,17.833H1149.6a8.917,8.917,0,1,0,0-17.833h-10.521a.625.625,0,0,1,0-1.249H1149.6a10.166,10.166,0,1,1,0,20.332",
    transform: "translate(-687.362 -1072.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M1209.442,1395.482H1076.163a.625.625,0,0,1,0-1.249h133.279a.625.625,0,0,1,0,1.249",
    transform: "translate(-770.581 -998.913)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    "data-name": "Grupo 96",
    transform: "translate(229.811 180.51)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_95",
    "data-name": "Grupo 95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    "data-name": "Grupo 94",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M813.556,648.292h35.4a3.049,3.049,0,0,0,3.049-3.049V639.68a3.049,3.049,0,0,0-3.049-3.049h-35.4a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-810.507 -636.631)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99",
    transform: "translate(229.393 207.877)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    "data-name": "Caminho 182",
    d: "M812.082,744.807h35.4a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049h-35.4a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-809.033 -733.147)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_102",
    "data-name": "Grupo 102",
    transform: "translate(229.393 232.755)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    "data-name": "Caminho 183",
    d: "M812.082,832.548h35.4a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049h-35.4a3.049,3.049,0,0,0-3.049,3.049V829.5a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-809.033 -820.888)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_105",
    "data-name": "Grupo 105",
    transform: "translate(293.387 180.51)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_104",
    "data-name": "Grupo 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_103",
    "data-name": "Grupo 103",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M1037.781,648.292h83.292a3.049,3.049,0,0,0,3.049-3.049V639.68a3.049,3.049,0,0,0-3.049-3.049h-83.292a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1034.732 -636.631)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_108",
    "data-name": "Grupo 108",
    transform: "translate(292.97 207.877)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_107",
    "data-name": "Grupo 107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_106",
    "data-name": "Grupo 106",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M1036.307,744.807h33.715a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049h-33.715a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1033.259 -733.147)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_111",
    "data-name": "Grupo 111",
    transform: "translate(292.97 232.755)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_110",
    "data-name": "Grupo 110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_109",
    "data-name": "Grupo 109",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M1036.307,832.548h53.567a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049h-53.567a3.049,3.049,0,0,0-3.049,3.049V829.5a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1033.259 -820.888)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_114",
    "data-name": "Grupo 114",
    transform: "translate(229.811 258.1)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_113",
    "data-name": "Grupo 113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_112",
    "data-name": "Grupo 112",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M813.556,921.938h35.4a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049h-35.4a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-810.507 -910.277)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_117",
    "data-name": "Grupo 117",
    transform: "translate(293.387 258.1)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_116",
    "data-name": "Grupo 116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_115",
    "data-name": "Grupo 115",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M1037.781,921.938h123.051a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049H1037.781a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1034.732 -910.277)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(432.355 258.1)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_189",
    "data-name": "Caminho 189",
    d: "M1527.9,921.938h71.3a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049h-71.3a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1524.848 -910.277)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123",
    transform: "translate(391.778 180.51)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_122",
    "data-name": "Grupo 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_121",
    "data-name": "Grupo 121",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_190",
    "data-name": "Caminho 190",
    d: "M1384.793,648.292h111.872a3.049,3.049,0,0,0,3.049-3.049V639.68a3.049,3.049,0,0,0-3.049-3.049H1384.793a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1381.743 -636.631)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126",
    transform: "translate(342.601 207.877)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M1211.348,744.807h102.876a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049H1211.348a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1208.299 -733.147)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    "data-name": "Grupo 129",
    transform: "translate(362.454 232.755)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    "data-name": "Caminho 192",
    d: "M1281.365,832.548h108.161a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049H1281.365a3.049,3.049,0,0,0-3.049,3.049V829.5a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1278.317 -820.888)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_132",
    "data-name": "Grupo 132",
    transform: "translate(230.229 283.77)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131",
    "data-name": "Grupo 131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_130",
    "data-name": "Grupo 130",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    "data-name": "Caminho 193",
    d: "M815.03,1012.475h35.4a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049h-35.4a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-811.981 -1000.814)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_135",
    "data-name": "Grupo 135",
    transform: "translate(230.604 306.493)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    "data-name": "Grupo 134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_133",
    "data-name": "Grupo 133",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    "data-name": "Caminho 194",
    d: "M816.353,1092.615h35.4a3.049,3.049,0,0,0,3.049-3.049V1084a3.049,3.049,0,0,0-3.049-3.049h-35.4A3.049,3.049,0,0,0,813.3,1084v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-813.304 -1080.954)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_138",
    "data-name": "Grupo 138",
    transform: "translate(293.806 283.77)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_137",
    "data-name": "Grupo 137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_136",
    "data-name": "Grupo 136",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    "data-name": "Caminho 195",
    d: "M1039.255,1012.475h123.051a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049H1039.255a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1036.207 -1000.814)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141",
    "data-name": "Grupo 141",
    transform: "translate(294.181 306.493)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_140",
    "data-name": "Grupo 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_139",
    "data-name": "Grupo 139",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_196",
    "data-name": "Caminho 196",
    d: "M1040.579,1092.615h53.567a3.049,3.049,0,0,0,3.049-3.049V1084a3.049,3.049,0,0,0-3.049-3.049h-53.567a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1037.53 -1080.954)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(432.772 283.77)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143",
    "data-name": "Grupo 143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_197",
    "data-name": "Caminho 197",
    d: "M1529.37,1012.475h71.3a3.049,3.049,0,0,0,3.049-3.049v-5.563a3.049,3.049,0,0,0-3.049-3.049h-71.3a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1526.321 -1000.814)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147",
    transform: "translate(363.665 306.493)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_198",
    "data-name": "Caminho 198",
    d: "M1285.636,1092.615H1393.8a3.049,3.049,0,0,0,3.049-3.049V1084a3.049,3.049,0,0,0-3.049-3.049H1285.636a3.049,3.049,0,0,0-3.049,3.049v5.563a3.049,3.049,0,0,0,3.049,3.049",
    transform: "translate(-1282.588 -1080.954)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_199",
    "data-name": "Caminho 199",
    d: "M1057.643,240.636s8.266,14.57,4.4,17.148-10.4-6.342-14.214-16.267-6.861-42.287-1.95-55.325,54.5-39.878,65.841-44.235,53.407-5.525,77.711,4.115,48.991,50.659,52.952,59.867,14.7,36.235-42.539,35.917h-45.563s-19.329-45.212-33.335-57.829c0,0-33.248,15.706-40.48,21.912,0,0-.247,3.643,2.96,11.708s9.875,20.758-1.1,20.467c-4.263-.113-7.6-9.29-11.422-9.76-6.016-.74-11.78,7.684-13.259,12.282",
    transform: "translate(-747.507 -99.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_200",
    "data-name": "Caminho 200",
    d: "M1058.971,257.394a4.067,4.067,0,0,1-1.234-.2c-4.377-1.392-9.337-9.745-12.092-16.916-3.718-9.679-7.031-42.285-1.951-55.769,5.071-13.462,55.026-40.3,66.2-44.6,11.634-4.471,54.232-5.376,78.166,4.117,24.415,9.684,49.172,50.615,53.3,60.2,1.933,4.5,6.462,15.023.684,23.745-5.819,8.784-20.538,13.172-43.8,13.044h-45.559a.625.625,0,0,1-.574-.379c-.191-.447-19.152-44.57-32.873-57.331-3.665,1.743-32.677,15.623-39.746,21.461.018.941.279,4.548,2.918,11.184.354.891.751,1.84,1.162,2.821,2.5,5.981,5.341,12.76,2.919,16.3-1.053,1.537-3.008,2.281-5.782,2.2-2.527-.067-4.606-2.74-6.616-5.324-1.624-2.089-3.3-4.248-4.865-4.44-5.443-.672-10.932,7.056-12.5,11.6,1.328,2.378,8.124,15.027,4.068,17.733a3.22,3.22,0,0,1-1.818.556m80.088-119.514c-12.713,0-23.669,1.255-28.716,3.194-11.964,4.6-60.744,31.3-65.48,43.872-4.991,13.25-1.715,45.344,1.949,54.881,3.19,8.3,7.944,15.1,11.3,16.173a2.183,2.183,0,0,0,1.98-.2c2.463-1.643-1.513-10.882-4.6-16.32a.626.626,0,0,1-.051-.5c1.6-4.98,7.623-13.486,13.93-12.711,2.075.255,3.835,2.518,5.7,4.913,1.833,2.355,3.727,4.791,5.665,4.843,2.369.06,3.909-.481,4.718-1.662,2.038-2.976-.778-9.7-3.04-15.108-.414-.988-.814-1.944-1.171-2.842-3.222-8.1-3.013-11.827-3-11.981a.627.627,0,0,1,.216-.432c7.214-6.189,39.259-21.36,40.62-22a.625.625,0,0,1,.685.1c13.426,12.1,31.3,52.976,33.328,57.669h45.151c22.8.129,37.184-4.074,42.755-12.484,5.4-8.159,1.064-18.252-.791-22.562-4.081-9.489-28.55-49.991-52.609-59.533-13.273-5.265-32.333-7.306-48.54-7.306",
    transform: "translate(-745.906 -97.911)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    "data-name": "Caminho 201",
    d: "M1556.985,323.105a.625.625,0,0,1-.542-.312,188.928,188.928,0,0,0-14.044-20.925.624.624,0,0,1,.988-.764,190.257,190.257,0,0,1,14.137,21.063.625.625,0,0,1-.54.937",
    transform: "translate(-1104.975 -215.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_202",
    "data-name": "Caminho 202",
    d: "M1501.551,380.206a.625.625,0,0,1-.016-1.249l30.36-.747a.614.614,0,0,1,.64.609.625.625,0,0,1-.609.64l-30.36.747h-.015",
    transform: "translate(-1075.355 -270.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_203",
    "data-name": "Caminho 203",
    d: "M1161.186,339.51a.625.625,0,0,1-.6-.443l-3.691-12.1a.624.624,0,1,1,1.194-.365l3.692,12.1a.625.625,0,0,1-.415.78.615.615,0,0,1-.182.027",
    transform: "translate(-828.852 -233.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_204",
    "data-name": "Caminho 204",
    d: "M1043.394,372.993a.624.624,0,0,1-.378-1.122,34.474,34.474,0,0,1,36.234-2.772.625.625,0,0,1-.6,1.1,33.191,33.191,0,0,0-34.884,2.668.619.619,0,0,1-.377.127",
    transform: "translate(-747.102 -261.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_205",
    "data-name": "Caminho 205",
    d: "M1329.241,384.621s16.011,15.914,14.06,33.718c0,0-39.694,3.1-44.161-4.037,0,0-9.355,2.966-7.381-3.761,0,0-9.438.3-6.217-5.16,0,0-8.547,2.8-6.357-3.81,0,0-11.623,11.923-13.986,10.973s-1.448-6.328,2.775-11.173,15.265-14.324,21.52-15.2,39.748-1.552,39.748-1.552",
    transform: "translate(-905.551 -275.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_206",
    "data-name": "Caminho 206",
    d: "M1323.733,418.057c-10.92,0-23.307-.875-26.416-4.611-1.378.381-5.339,1.267-7.154-.51a3.515,3.515,0,0,1-.774-3.351c-1.649-.045-5.177-.376-6.343-2.345a2.966,2.966,0,0,1-.2-2.5c-1.571.338-4.112.612-5.427-.707a2.9,2.9,0,0,1-.8-2.163c-3.723,3.707-11.013,10.563-13.236,9.672a2.615,2.615,0,0,1-1.541-1.937c-.615-2.561,1.062-6.766,4.078-10.227,4.4-5.045,15.478-14.508,21.9-15.406,6.22-.869,38.453-1.53,39.822-1.558a.651.651,0,0,1,.453.181c.162.162,16.2,16.334,14.24,34.23a.625.625,0,0,1-.572.555c-.733.057-8.87.674-18.04.674m-26.17-5.958a.626.626,0,0,1,.529.293c3.446,5.5,31.75,4.628,43.062,3.785,1.444-16.083-12.012-30.694-13.749-32.5-3.2.067-33.553.723-39.4,1.54-6.033.844-16.966,10.207-21.135,14.99-3.085,3.54-4.249,7.265-3.8,9.114a1.4,1.4,0,0,0,.792,1.07c1.078.43,7.164-4.531,13.306-10.83a.624.624,0,0,1,1.04.632c-.471,1.424-.436,2.422.106,2.965,1.132,1.136,4.407.4,5.463.055a.625.625,0,0,1,.733.911c-.614,1.039-.742,1.875-.382,2.484.915,1.546,4.678,1.774,6.041,1.734a.613.613,0,0,1,.514.242.624.624,0,0,1,.105.558c-.4,1.369-.316,2.346.255,2.905,1.326,1.3,5.024.5,6.338.085a.618.618,0,0,1,.189-.029",
    transform: "translate(-903.974 -273.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M1108.9,443.341a3.35,3.35,0,0,0-.405.027,13.619,13.619,0,0,0-1.557-3.753,3.338,3.338,0,1,0-4.42-4.987,3.271,3.271,0,0,0-.268.305,13.649,13.649,0,0,0-3.758-1.555,3.342,3.342,0,1,0-6.629,0,13.649,13.649,0,0,0-3.758,1.555,3.287,3.287,0,0,0-.268-.305,3.34,3.34,0,1,0-4.42,4.987,13.619,13.619,0,0,0-1.557,3.753,3.338,3.338,0,1,0,0,6.621,13.615,13.615,0,0,0,1.557,3.753,3.339,3.339,0,1,0,4.688,4.682,13.646,13.646,0,0,0,3.758,1.554,3.342,3.342,0,1,0,6.629,0,13.646,13.646,0,0,0,3.758-1.554,3.307,3.307,0,0,0,.268.305,3.34,3.34,0,1,0,4.42-4.987,13.615,13.615,0,0,0,1.557-3.753,3.337,3.337,0,1,0,.405-6.648m-13.722,9.536a6.2,6.2,0,1,1,6.206-6.2,6.2,6.2,0,0,1-6.206,6.2",
    transform: "translate(-772.429 -307.817)",
    fill: "#790000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M1383.678,142.533s-6.019,8.081,2.419,12.267,22.682-9.812,19.926-19.8c-1.637-5.932-9.93-7.1-9.93-7.1l-6.483-2.863-11.083,13.274Z",
    transform: "translate(-987.66 -89.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M1387.912,154.6a8.184,8.184,0,0,1-3.67-.825c-2.565-1.273-4.131-3.026-4.654-5.213-.762-3.18.923-6.3,1.676-7.492l-4.711-3.862a.625.625,0,0,1-.083-.884l11.083-13.274a.624.624,0,0,1,.732-.171l6.406,2.83c.971.153,8.7,1.552,10.356,7.539,1.709,6.192-2.714,13.3-7.546,17.289-3.229,2.664-6.606,4.062-9.59,4.062m-10.079-17.958,4.664,3.824a.625.625,0,0,1,.106.855c-.026.035-2.612,3.575-1.8,6.957.435,1.807,1.778,3.28,3.993,4.378,3.2,1.586,7.649.434,11.909-3.081,4.531-3.738,8.7-10.338,7.136-15.993-1.506-5.461-9.336-6.636-9.416-6.648a.637.637,0,0,1-.165-.047l-6.052-2.673Z",
    transform: "translate(-986.083 -88.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M1400.319,189.157l3.218,2.143Z",
    transform: "translate(-1003.274 -135.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M1401.957,190.346a.623.623,0,0,1-.346-.1l-3.218-2.143a.625.625,0,0,1,.693-1.04l3.218,2.143a.625.625,0,0,1-.347,1.145",
    transform: "translate(-1001.695 -133.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M1353.28,14.9a9.485,9.485,0,0,0-4.567-5.223,6.5,6.5,0,0,0-6.721.58,26.789,26.789,0,0,0-10.4-7.1,14.8,14.8,0,0,0-12.285.923,14.673,14.673,0,0,0-6.437,10.068,15.779,15.779,0,0,0,3.543,13.316c3.228,3.5,8.625,5.045,13.03,3.233a6.455,6.455,0,0,0,2.873,3.94,15.857,15.857,0,0,0,4.611,1.9,60.458,60.458,0,0,0,7.787,1.622c1.515.213,3.924.536,5.22-.536.933-.773,1.416-2.831,1.863-3.925a33.471,33.471,0,0,0,2.482-11.807,18.04,18.04,0,0,0-1-6.986",
    transform: "translate(-940.434 -1.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M1361.11,82.993s-3.573-2.68-3.295-9.518a24.477,24.477,0,0,0-15.451-7.528s-8.085,17.553-7,25.755,12.946,15.284,25.749.492c0,0,8.755.875,10.779-6.15s-5.726-9.658-10.779-3.051",
    transform: "translate(-956.662 -47.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M1344.576,99.844a12.115,12.115,0,0,1-3.478-.5,11.3,11.3,0,0,1-7.934-9.139c-1.093-8.285,6.722-25.375,7.055-26.1a.616.616,0,0,1,.623-.361,24.88,24.88,0,0,1,15.871,7.745.62.62,0,0,1,.148.43c-.2,5.014,1.707,7.635,2.6,8.58,3.069-3.623,6.819-4.1,9.095-2.95,1.855.935,3.447,3.287,2.352,7.087-1.912,6.633-9.433,6.688-11.11,6.619-6.062,6.9-11.433,8.586-15.226,8.587m-3.4-34.81c-1.188,2.665-7.725,17.758-6.769,25.007a10.037,10.037,0,0,0,7.054,8.106c3.181.954,9.7,1.19,17.6-7.941a.613.613,0,0,1,.534-.213c.335.033,8.263.733,10.118-5.7.75-2.6.11-4.706-1.714-5.625-1.942-.978-5.261-.415-7.97,3.126a.623.623,0,0,1-.871.12c-.155-.116-3.743-2.889-3.553-9.786a24.2,24.2,0,0,0-14.433-7.093",
    transform: "translate(-955.085 -45.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M1428.649,137.157a.625.625,0,0,1-.467-1.039,8.716,8.716,0,0,1,5.348-2.82.625.625,0,1,1,.157,1.239,7.449,7.449,0,0,0-4.571,2.41.624.624,0,0,1-.467.21",
    transform: "translate(-1023.123 -95.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M2147.125,1381.877l27.159,38.71h-69.6c-1.944-3.841-4.572-9.059-7.388-14.735a59.036,59.036,0,0,1,8.99-65.737c23.363-25.978,59.527-58.016,74.976-72.862a71.59,71.59,0,0,1,6.743-5.947c14.214-10.132,49.307,24.734,49.307,24.734l-43.248,49.108Z",
    transform: "translate(-1498.218 -902.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M2103.1,1419.634a.625.625,0,0,1-.558-.343c-2.572-5.083-5.059-10.043-7.39-14.74a59.659,59.659,0,0,1,9.085-66.432c17.359-19.3,41.723-41.9,59.513-58.393,6.179-5.73,11.516-10.679,15.494-14.5a71.809,71.809,0,0,1,6.814-6.006c14.473-10.319,48.662,23.361,50.11,24.8a.625.625,0,0,1,.028.856l-43.248,49.108-46.6,46.389,26.129,37.242a.624.624,0,1,1-1.022.717l-26.431-37.673a.623.623,0,0,1,.071-.8l46.941-46.73,42.827-48.632c-4-3.865-35.279-33.386-48.084-24.258a70.814,70.814,0,0,0-6.672,5.889c-3.987,3.831-9.327,8.783-15.51,14.517-17.772,16.481-42.113,39.052-59.435,58.312a58.119,58.119,0,0,0-8.9,65.041c2.33,4.694,4.814,9.651,7.386,14.731a.625.625,0,0,1-.557.907",
    transform: "translate(-1496.63 -900.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M2248.51,1700.553a.625.625,0,0,1-.429-1.079l10.918-10.3a.625.625,0,1,1,.857.909l-10.918,10.3a.624.624,0,0,1-.429.17",
    transform: "translate(-1610.521 -1210.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M2340.037,1416.792h-84.346l77.495-140.479,39.309-22.151c.378,1.019,15.921,16.011,4.356,56.778-8.888,31.328-28.3,83.411-36.814,105.851",
    transform: "translate(-1616.114 -898.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M2551.589,1415.839a.617.617,0,0,1-.221-.041.625.625,0,0,1-.363-.806c8.085-21.311,27.854-74.28,36.8-105.8,6.746-23.779,5.387-43.534-3.828-55.626a3.479,3.479,0,0,1-.513-.764.624.624,0,0,1,1.158-.465c.043.072.2.275.348.472,9.458,12.412,10.892,32.558,4.036,56.725-8.957,31.568-28.74,84.577-36.831,105.9a.624.624,0,0,1-.584.4",
    transform: "translate(-1827.666 -896.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    "data-name": "Caminho 221",
    d: "M2254.111,1545.719a.624.624,0,0,1-.546-.926l61.359-111.229a.625.625,0,0,1,1.094.6L2254.658,1545.4a.625.625,0,0,1-.548.323",
    transform: "translate(-1614.534 -1026.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_222",
    "data-name": "Caminho 222",
    d: "M2071.092,920.936l-21.985-18.542s8.4-13.744-6.417-20.919c-4.867-2.357.867,13.252-11.234,25.53v9.123l21.5,21.444s14.244-6.039,18.137-16.637",
    transform: "translate(-1455.458 -631.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_223",
    "data-name": "Caminho 223",
    d: "M2051.376,936.615a.625.625,0,0,1-.441-.183l-21.5-21.444a.625.625,0,0,1-.184-.443v-9.123a.628.628,0,0,1,.18-.439c7.009-7.111,7.919-15.5,8.463-20.513.314-2.9.5-4.644,1.6-5.25a1.973,1.973,0,0,1,1.889.11c4.59,2.223,7.489,5.3,8.616,9.134,1.59,5.414-.833,10.632-1.674,12.2l21.59,18.208a.625.625,0,0,1,.183.693c-3.942,10.729-17.888,16.746-18.479,17a.629.629,0,0,1-.244.05M2030.5,914.286l21.011,20.958c2.237-1.032,13.668-6.677,17.259-15.7l-21.646-18.255a.625.625,0,0,1-.13-.8c.035-.058,3.514-5.872,1.8-11.679-1.025-3.481-3.7-6.291-7.959-8.352-.2-.1-.559-.24-.74-.142-.528.293-.739,2.236-.962,4.292-.557,5.132-1.485,13.692-8.636,21.072Z",
    transform: "translate(-1453.879 -629.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_224",
    "data-name": "Caminho 224",
    d: "M2188.1,1020.8s22.537,22.329,79.77-8.734c0,0-30.711-67.881-35.351-75.664a23.508,23.508,0,0,0-12.773-9.986s2.864-14.2-17.671-14.2c0,0-19.438-1.6-16.879,10.929,0,0-31.785,14.945-45.713,29.345l-14.063-9.407L2110,956.7l-2.717,33.241s16.591,20.308,36.783,23.409,37.158-6.312,37.158-6.312Z",
    transform: "translate(-1509.783 -653.52)",
    fill: "#790000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_225",
    "data-name": "Caminho 225",
    d: "M2372.242,1179.022a.625.625,0,0,1-.194-1.219,96.02,96.02,0,0,0,40.1-25.515.625.625,0,0,1,.911.854,97.277,97.277,0,0,1-40.619,25.848.628.628,0,0,1-.194.031",
    transform: "translate(-1699.17 -825.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_226",
    "data-name": "Caminho 226",
    d: "M2223.952,1070.341a.625.625,0,0,1-.2-1.215c22.876-7.875,39.363-17.387,51.884-29.934a.625.625,0,1,1,.884.882c-12.66,12.687-29.3,22.293-52.361,30.232a.624.624,0,0,1-.2.035",
    transform: "translate(-1592.927 -744.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_227",
    "data-name": "Caminho 227",
    d: "M2189.948,1106.671a.622.622,0,0,1-.444-.184,187.911,187.911,0,0,0-16.1-14.462.625.625,0,0,1,.78-.976,189.136,189.136,0,0,1,16.21,14.559.624.624,0,0,1-.443,1.064",
    transform: "translate(-1556.988 -781.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_228",
    "data-name": "Caminho 228",
    d: "M1883.24,806.73a7.76,7.76,0,0,0-.725-.605,31.645,31.645,0,0,0,3.419-8.807,7.758,7.758,0,1,0,.589-15.474,7.856,7.856,0,0,0-.941.084,31.64,31.64,0,0,0-3.818-8.641,7.887,7.887,0,0,0,.7-.638,7.765,7.765,0,1,0-11.842-10,31.721,31.721,0,0,0-8.817-3.415,7.77,7.77,0,1,0-15.409.351,31.744,31.744,0,0,0-8.652,3.813,7.766,7.766,0,1,0-10.647,11.131,31.625,31.625,0,0,0-3.419,8.807,7.76,7.76,0,1,0,.352,15.39,31.652,31.652,0,0,0,3.818,8.641,7.764,7.764,0,1,0,11.145,10.634,31.727,31.727,0,0,0,8.817,3.415,7.77,7.77,0,1,0,15.409-.351,31.734,31.734,0,0,0,8.652-3.813,7.762,7.762,0,1,0,11.372-10.526m-38.4-5.981a14.419,14.419,0,1,1,20.4-.465,14.4,14.4,0,0,1-20.4.465",
    transform: "translate(-1300.476 -537.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_229",
    "data-name": "Caminho 229",
    d: "M1853.951,828.992a8.4,8.4,0,0,1-8.389-8.193c0-.151,0-.307,0-.47a32.321,32.321,0,0,1-8-3.1c-.105.126-.21.242-.315.352A8.389,8.389,0,1,1,1825.117,806q.155-.163.335-.328a32.282,32.282,0,0,1-3.462-7.836c-.162.014-.318.023-.47.026a8.384,8.384,0,1,1-.383-16.764c.151,0,.308,0,.471,0a32.211,32.211,0,0,1,3.1-7.986c-.126-.1-.242-.209-.351-.313a8.378,8.378,0,0,1-.271-11.855,8.411,8.411,0,0,1,11.867-.271q.164.157.329.336a32.348,32.348,0,0,1,7.847-3.458c-.014-.162-.022-.318-.026-.468a8.388,8.388,0,0,1,8.2-8.574l.195,0a8.4,8.4,0,0,1,8.388,8.193c0,.15,0,.306,0,.469a32.336,32.336,0,0,1,8,3.1c.1-.125.209-.24.314-.351a8.412,8.412,0,0,1,11.867-.27,8.378,8.378,0,0,1,.271,11.855c-.1.109-.215.217-.335.328a32.239,32.239,0,0,1,3.462,7.836c.163-.014.318-.023.47-.026a8.384,8.384,0,1,1,.382,16.764c-.151,0-.307,0-.47,0a32.286,32.286,0,0,1-3.1,7.986c.125.105.241.209.35.313a8.378,8.378,0,0,1,.271,11.855,8.41,8.41,0,0,1-11.867.271c-.109-.1-.218-.216-.33-.336a32.333,32.333,0,0,1-7.847,3.458c.014.163.022.318.026.469a8.389,8.389,0,0,1-8.2,8.573l-.194,0m-16.54-13.19a.619.619,0,0,1,.309.082,31.087,31.087,0,0,0,8.643,3.347.625.625,0,0,1,.485.671,7.059,7.059,0,0,0-.038.867,7.144,7.144,0,0,0,14.285-.325,7.059,7.059,0,0,0-.077-.865.624.624,0,0,1,.454-.692,31.089,31.089,0,0,0,8.482-3.738.624.624,0,0,1,.817.131,7.138,7.138,0,1,0,10.458-9.678h0a7.069,7.069,0,0,0-.667-.556.625.625,0,0,1-.168-.811,31.026,31.026,0,0,0,3.352-8.633.622.622,0,0,1,.671-.485,7.135,7.135,0,1,0-.325-14.151.629.629,0,0,1-.691-.454,31.008,31.008,0,0,0-3.743-8.471.624.624,0,0,1,.132-.818,7.172,7.172,0,0,0,.641-.587,7.128,7.128,0,0,0-.23-10.087,7.11,7.11,0,0,0-10.66.9.624.624,0,0,1-.81.168,31.1,31.1,0,0,0-8.643-3.347.624.624,0,0,1-.485-.671,7.142,7.142,0,1,0-14.247-.541,7.052,7.052,0,0,0,.077.865.625.625,0,0,1-.454.692,31.089,31.089,0,0,0-8.482,3.738.624.624,0,0,1-.817-.131,7.106,7.106,0,0,0-10.689-.41,7.09,7.09,0,0,0,.9,10.644.625.625,0,0,1,.169.811,30.983,30.983,0,0,0-3.352,8.633.631.631,0,0,1-.67.485,7.056,7.056,0,0,0-5.872,2.166,7.136,7.136,0,0,0,5.33,12.062,7.227,7.227,0,0,0,.865-.078.625.625,0,0,1,.692.454,31.029,31.029,0,0,0,3.743,8.471.624.624,0,0,1-.132.817,7.137,7.137,0,1,0,9.691,10.444,6.843,6.843,0,0,0,.558-.666.624.624,0,0,1,.5-.251m15.811-12.023a15.033,15.033,0,1,1,10.887-4.642,15.008,15.008,0,0,1-10.887,4.642m.006-28.808a13.785,13.785,0,1,0,9.532,3.812,13.775,13.775,0,0,0-9.532-3.812",
    transform: "translate(-1298.897 -536.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_230",
    "data-name": "Caminho 230",
    d: "M1942.708,979.538s27.3,32.323,34.217,35.63c0,0,18.012-16.789,20.566-25.047L1964.615,964.1a11.71,11.71,0,0,1-4.184-6.775,31.739,31.739,0,0,0-2.309-6.868c-2.781-5.945-6.14-4.93-5.674-1.335s-1.135,8.01-1.135,8.01-12.734-13.112-15.922-12.028,5.535,10.964,5.535,10.964-13.1-11.2-15.179-9.358c-2.726,2.412,9.085,13.332,9.085,13.332s-10.531-8.584-12.757-5.668c-2.085,2.732,9.907,11.54,9.907,11.54s-7.847-4.79-9.127-2.456,13.175,13.1,19.854,16.08",
    transform: "translate(-1376.916 -677.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_231",
    "data-name": "Caminho 231",
    d: "M1975.345,1014.248a.627.627,0,0,1-.269-.061c-6.821-3.263-32.3-33.283-34.332-35.682-6.006-2.729-18.85-12.03-20.06-15.622a1.546,1.546,0,0,1,.043-1.27,1.8,1.8,0,0,1,1.158-.871,6.871,6.871,0,0,1,3.695.557c-2.692-2.348-5.636-5.329-5.927-7.353a1.924,1.924,0,0,1,.346-1.5,2.169,2.169,0,0,1,1.538-.828c1.638-.2,4.092.95,6.37,2.325-2.417-2.709-4.793-5.871-4.772-7.811a1.888,1.888,0,0,1,.618-1.44c1.606-1.422,7.046,2.218,11.493,5.672-1.626-2.3-3.073-4.868-2.694-6.291a1.561,1.561,0,0,1,1.057-1.111c3.1-1.052,12.6,8.161,15.843,11.441a18.181,18.181,0,0,0,.8-6.751c-.232-1.8.4-3.183,1.6-3.535,1.336-.39,3.417.6,5.254,4.525a32.277,32.277,0,0,1,2.355,7,11.114,11.114,0,0,0,3.96,6.414l32.877,26.021a.625.625,0,0,1-.775.98l-32.877-26.021a12.365,12.365,0,0,1-4.407-7.135,30.986,30.986,0,0,0-2.264-6.732c-1.4-2.994-2.939-4.1-3.774-3.855-.574.167-.861,1.041-.714,2.175.479,3.7-1.1,8.117-1.167,8.3a.625.625,0,0,1-1.036.222c-5.173-5.327-13.338-12.529-15.273-11.872a.326.326,0,0,0-.252.249c-.4,1.512,3.3,6.588,6.055,9.71a.625.625,0,0,1-.874.888c-6.761-5.777-13.475-10.147-14.359-9.365a.636.636,0,0,0-.2.518c-.029,2.677,6.7,9.489,9.292,11.888a.625.625,0,0,1-.818.943c-2.217-1.807-8.541-6.432-11.175-6.118a.923.923,0,0,0-.691.345.688.688,0,0,0-.1.56c.374,2.6,7.26,8.172,9.882,10.1a.625.625,0,0,1-.695,1.037c-2.228-1.359-6.335-3.361-7.87-2.953a.547.547,0,0,0-.384.265c-.126.347.874,2.406,6.928,7.121a72.108,72.108,0,0,0,12.633,8.087.623.623,0,0,1,.222.168c.272.322,27.295,32.258,34.01,35.47a.625.625,0,0,1-.27,1.188",
    transform: "translate(-1375.337 -675.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_232",
    "data-name": "Caminho 232",
    d: "M1965.228,996.309a.622.622,0,0,1-.391-.138l-5.037-4.058a.624.624,0,0,1,.783-.973l5.037,4.058a.625.625,0,0,1-.392,1.111",
    transform: "translate(-1403.953 -710.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_233",
    "data-name": "Caminho 233",
    d: "M1956.12,1017.641a.621.621,0,0,1-.359-.114c-.021-.015-2.06-1.454-3.491-2.53a.624.624,0,0,1,.75-1c1.417,1.065,3.441,2.493,3.461,2.508a.624.624,0,0,1-.36,1.135",
    transform: "translate(-1398.546 -726.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_234",
    "data-name": "Caminho 234",
    d: "M1984.726,980.2a.623.623,0,0,1-.442-.183l-2.507-2.506a.624.624,0,0,1,.883-.883l2.507,2.506a.624.624,0,0,1-.441,1.066",
    transform: "translate(-1419.734 -699.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_235",
    "data-name": "Caminho 235",
    d: "M2396.963,873l2.979,15.956s4.844,2.583,16.973-.366l-5.289-18.848Z",
    transform: "translate(-1717.33 -623.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_236",
    "data-name": "Caminho 236",
    d: "M2404.869,889.058c-4.613,0-6.67-1.054-6.8-1.123a.625.625,0,0,1-.32-.436l-2.979-15.957a.625.625,0,0,1,.479-.724l14.663-3.258a.624.624,0,0,1,.737.441l5.289,18.848a.625.625,0,0,1-.454.775,45.226,45.226,0,0,1-10.615,1.434m-5.954-2.115c1.115.433,5.9,1.879,15.644-.383l-4.954-17.653-13.5,3Z",
    transform: "translate(-1715.75 -621.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_237",
    "data-name": "Caminho 237",
    d: "M2405.234,933.932a34.362,34.362,0,0,1-10.047-1.387.625.625,0,1,1,.394-1.185,36.418,36.418,0,0,0,22.488-1.053.625.625,0,1,1,.455,1.163,36.448,36.448,0,0,1-13.29,2.462",
    transform: "translate(-1715.751 -666.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_238",
    "data-name": "Caminho 238",
    d: "M2389.286,768.751a24.808,24.808,0,0,0,19.455-11.719c7.269-11.368-3.424-27.475-13.9-31.284s-24.026-6.342-31.7,5.528,9.838,18.391,9.838,18.391Z",
    transform: "translate(-1691.702 -517.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_239",
    "data-name": "Caminho 239",
    d: "M2392.321,802.927s5.738-1.408,7.6,1.666-3.863,9.319-9.356,7.486c0,0-13.07,5.217-20.006.331s3.9-26.954,6.909-30.68c0,0,5.5,7.96,11.6,6.314s11.212-2.732,8.907,3.839c-2.108,6.006-6.932,6.877-5.658,11.044",
    transform: "translate(-1696.783 -560.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_240",
    "data-name": "Caminho 240",
    d: "M2376.9,813.557a14.269,14.269,0,0,1-8.275-2.214,6.289,6.289,0,0,1-2.425-4.511c-1.186-8.51,6.837-24.14,9.208-27.072a.62.62,0,0,1,.509-.231.626.626,0,0,1,.49.268c.052.076,5.329,7.577,10.924,6.067,4.459-1.2,7.995-1.993,9.549-.319.905.974.941,2.6.11,4.968a16.84,16.84,0,0,1-3.791,5.939c-1.338,1.494-2.265,2.531-1.99,4.166,1.621-.286,5.96-.747,7.672,2.074.854,1.407.463,3.435-1.021,5.293-1.886,2.362-5.332,4.231-8.848,3.179a37.508,37.508,0,0,1-12.113,2.394m-1-32.353c-2.688,3.98-9.511,17.938-8.463,25.455a5.1,5.1,0,0,0,1.907,3.663c6.581,4.638,19.286-.35,19.414-.4a.625.625,0,0,1,.429-.012c3,1,6.095-.7,7.7-2.7,1.148-1.437,1.5-2.919.929-3.865-1.609-2.651-6.868-1.4-6.921-1.384a.625.625,0,0,1-.746-.424c-.807-2.641.55-4.158,2.123-5.914a15.572,15.572,0,0,0,3.543-5.52c.449-1.281.841-2.963.153-3.7-1.164-1.252-5.461-.093-8.308.675-5.4,1.456-10.2-3.889-11.756-5.866",
    transform: "translate(-1695.203 -558.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_241",
    "data-name": "Caminho 241",
    d: "M2447.053,872.078a.625.625,0,0,1-.491-1.01,4.711,4.711,0,0,1,5.139-1.5.625.625,0,1,1-.415,1.178,3.477,3.477,0,0,0-3.741,1.092.623.623,0,0,1-.492.239",
    transform: "translate(-1752.77 -622.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_242",
    "data-name": "Caminho 242",
    d: "M2527.662,866.568a3.528,3.528,0,1,1-3.528-3.523,3.526,3.526,0,0,1,3.528,3.523",
    transform: "translate(-1805.915 -618.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_243",
    "data-name": "Caminho 243",
    d: "M2624.85,987.325a4.262,4.262,0,1,1-4.262-4.257,4.26,4.26,0,0,1,4.262,4.257",
    transform: "translate(-1874.494 -704.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_244",
    "data-name": "Caminho 244",
    d: "M2607.106,1157.593a3.3,3.3,0,1,1-3.3-3.3,3.3,3.3,0,0,1,3.3,3.3",
    transform: "translate(-1863.155 -827.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_245",
    "data-name": "Caminho 245",
    d: "M2540.081,883.808c-3.854,3.575-4.005,10.077-2.18,14.572,3.292,8.108,14.525,13.413,21.466,8.877,5.248-3.429,6.705-11.61,4.025-17.362-4.029-8.645-17.329-11.636-23.312-6.088",
    transform: "translate(-1817.495 -631.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_246",
    "data-name": "Caminho 246",
    d: "M2603.287,1024.9c-7.9-.8-15.735,8.979-15.261,18.09.319,6.123,4.5,14.009,11.721,14.841,7.407.853,13.414-6.245,14.944-12.5,2.152-8.784-3.615-19.648-11.4-20.435",
    transform: "translate(-1854.205 -734.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_247",
    "data-name": "Caminho 247",
    d: "M2547.534,1184.472c1.448,0,5.693.015,8.1,2.859,3.366,3.977,1.42,11.459-1.174,16.08-4.308,7.676-11.415,9.261-11.072,14.069a7.021,7.021,0,0,0,2.612,4.533,12.443,12.443,0,0,1-8.31,1.833c-7.565-1.326-12.336-11.476-11.739-19.6.838-11.388,12.31-19.8,21.584-19.776",
    transform: "translate(-1809.708 -848.628)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150",
    "data-name": "Grupo 150",
    transform: "translate(38.944 141.818)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_149",
    "data-name": "Grupo 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148",
    "data-name": "Grupo 148",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_248",
    "data-name": "Caminho 248",
    d: "M151.405,507.2a7.028,7.028,0,1,0-7.028,7.033,7.03,7.03,0,0,0,7.028-7.033",
    transform: "translate(-137.349 -500.17)",
    fill: "#f26f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_249",
    "data-name": "Caminho 249",
    d: "M223.741,507.2a7.028,7.028,0,1,0-7.028,7.033,7.03,7.03,0,0,0,7.028-7.033",
    transform: "translate(-189.175 -500.17)",
    fill: "#f26f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_250",
    "data-name": "Caminho 250",
    d: "M296.078,507.2a7.028,7.028,0,1,0-7.028,7.033,7.03,7.03,0,0,0,7.028-7.033",
    transform: "translate(-241.001 -500.17)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_251",
    "data-name": "Caminho 251",
    d: "M423.651,524.019H355.927a.625.625,0,0,1,0-1.249h67.723a.625.625,0,1,1,0,1.249",
    transform: "translate(-254.561 -374.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_252",
    "data-name": "Caminho 252",
    d: "M210.42,91.889h80.434a4.667,4.667,0,0,0,4.667-4.667V6.87A4.667,4.667,0,0,0,290.854,2.2H210.42a4.667,4.667,0,0,0-4.667,4.667V87.222a4.667,4.667,0,0,0,4.667,4.667",
    transform: "translate(-147.414 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_253",
    "data-name": "Caminho 253",
    d: "M289.275,90.935H208.841a5.3,5.3,0,0,1-5.292-5.292V5.292A5.3,5.3,0,0,1,208.841,0h80.434a5.3,5.3,0,0,1,5.292,5.292V85.644a5.3,5.3,0,0,1-5.292,5.292M208.841,1.249A4.047,4.047,0,0,0,204.8,5.292V85.644a4.047,4.047,0,0,0,4.043,4.042h80.434a4.047,4.047,0,0,0,4.043-4.042V5.292a4.047,4.047,0,0,0-4.043-4.042Z",
    transform: "translate(-145.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_254",
    "data-name": "Caminho 254",
    d: "M231.8,138.983s14.109-36.649,27.009-36.649,19.752,28.192,24.59,28.192,5.644-10.874,10.884-10.874,12.5,19.332,12.5,19.332-74.979-.671-74.979,0",
    transform: "translate(-166.073 -73.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_255",
    "data-name": "Caminho 255",
    d: "M230.218,138.029a.623.623,0,0,1-.583-.849h0c.582-1.513,14.414-37.05,27.591-37.05,8.379,0,14.251,11.222,18.539,19.416,2.258,4.314,4.592,8.775,6.051,8.775,2,0,3.287-2.4,4.654-4.945,1.566-2.915,3.184-5.929,6.23-5.929,5.514,0,12.324,17.716,13.082,19.737a.625.625,0,0,1-.073.578.681.681,0,0,1-.517.267c-28.781-.257-72.142-.484-74.7-.063a.62.62,0,0,1-.272.063m18.945-1.55c4.9,0,11.059.016,18.8.05,16.116.073,32.352.209,36.325.243-2.245-5.747-7.84-18.075-11.586-18.075-2.3,0-3.674,2.56-5.13,5.271-1.48,2.755-3.01,5.6-5.754,5.6-2.215,0-4.288-3.962-7.157-9.445-4.141-7.911-9.81-18.747-17.433-18.747-11.194,0-23.736,29.6-26.049,35.307,1.88-.122,6.466-.208,17.986-.208",
    transform: "translate(-164.494 -71.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_256",
    "data-name": "Caminho 256",
    d: "M405.423,88.086a5.644,5.644,0,1,0,5.644-5.638,5.641,5.641,0,0,0-5.644,5.638",
    transform: "translate(-290.47 -59.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_257",
    "data-name": "Caminho 257",
    d: "M409.488,92.771a6.263,6.263,0,1,1,6.268-6.263,6.273,6.273,0,0,1-6.268,6.263m0-11.277a5.014,5.014,0,1,0,5.019,5.014,5.022,5.022,0,0,0-5.019-5.014",
    transform: "translate(-288.891 -57.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_258",
    "data-name": "Caminho 258",
    d: "M647.162,220.507a.624.624,0,0,1-.625-.625V141.718H549.921a.625.625,0,0,1,0-1.249h97.242a.625.625,0,0,1,.625.625v78.789a.624.624,0,0,1-.625.625",
    transform: "translate(-393.549 -100.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_259",
    "data-name": "Caminho 259",
    d: "M354.63,268.327H458.085l22.664,23.127-22.664,23.985H354.63Z",
    transform: "translate(-254.078 -192.246)",
    fill: "#790000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_260",
    "data-name": "Caminho 260",
    d: "M701.095,334.047a6.109,6.109,0,1,1-6.109-6.109,6.109,6.109,0,0,1,6.109,6.109",
    transform: "translate(-493.553 -234.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_261",
    "data-name": "Caminho 261",
    d: "M2141.413,453.12H2102.6a.625.625,0,1,1,0-1.249h38.187V361.734a.624.624,0,0,1,.625-.625h47.107a.625.625,0,1,1,0,1.249h-46.482V452.5a.624.624,0,0,1-.625.625",
    transform: "translate(-1505.984 -258.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_262",
    "data-name": "Caminho 262",
    d: "M2292.627,398.039h-20.059a.625.625,0,0,1,0-1.249h20.059a.625.625,0,1,1,0,1.249",
    transform: "translate(-1627.759 -284.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_263",
    "data-name": "Caminho 263",
    d: "M2286.527,429H2272.57a.625.625,0,0,1,0-1.249h13.957a.625.625,0,0,1,0,1.249",
    transform: "translate(-1627.759 -306.468)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153",
    transform: "translate(689.009 95.981)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151",
    "data-name": "Grupo 151",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_264",
    "data-name": "Caminho 264",
    d: "M2444.086,345.541a7.028,7.028,0,1,0-7.028,7.033,7.031,7.031,0,0,0,7.028-7.033",
    transform: "translate(-2430.03 -338.509)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156",
    "data-name": "Grupo 156",
    transform: "translate(709.52 95.981)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_265",
    "data-name": "Caminho 265",
    d: "M2516.422,345.541a7.028,7.028,0,1,0-7.028,7.033,7.031,7.031,0,0,0,7.028-7.033",
    transform: "translate(-2502.367 -338.509)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159",
    transform: "translate(730.029 95.981)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_157",
    "data-name": "Grupo 157",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_266",
    "data-name": "Caminho 266",
    d: "M2588.759,345.541a7.028,7.028,0,1,0-7.028,7.033,7.031,7.031,0,0,0,7.028-7.033",
    transform: "translate(-2574.702 -338.509)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_162",
    "data-name": "Grupo 162",
    transform: "translate(578.307 186.742)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_161",
    "data-name": "Grupo 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_160",
    "data-name": "Grupo 160",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_267",
    "data-name": "Caminho 267",
    d: "M2053.658,665.644a7.028,7.028,0,1,0-7.029,7.033,7.031,7.031,0,0,0,7.029-7.033",
    transform: "translate(-2039.601 -658.611)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_268",
    "data-name": "Caminho 268",
    d: "M861.832,1172.693H773.313a2.557,2.557,0,0,1-2.444-3.466c1.044-2.2,3.2-2.979,6.391-2.979h90.38l-1.173,3.209a4.95,4.95,0,0,1-4.635,3.236",
    transform: "translate(-552.182 -835.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_269",
    "data-name": "Caminho 269",
    d: "M945.513,1070.216l16.756-42.328a3.429,3.429,0,0,0-.343-3.176,3.381,3.381,0,0,0-2.8-1.5h-54.4a7.742,7.742,0,0,0-7.3,5.19l-14.709,41.811Z",
    transform: "translate(-632.43 -733.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_270",
    "data-name": "Caminho 270",
    d: "M1047.9,1070.1a2.056,2.056,0,1,1-2.056-2.07,2.063,2.063,0,0,1,2.056,2.07",
    transform: "translate(-747.832 -765.199)",
    fill: "#790000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_271",
    "data-name": "Caminho 271",
    d: "M223.379,1085.938c0,40.2-32.374,72.786-72.309,72.786s-72.31-32.587-72.31-72.786,32.374-72.786,72.31-72.786,72.309,32.587,72.309,72.786",
    transform: "translate(-56.428 -725.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_272",
    "data-name": "Caminho 272",
    d: "M149.492,1157.77c-40.216,0-72.933-32.932-72.933-73.411s32.718-73.411,72.933-73.411,72.934,32.932,72.934,73.411-32.718,73.411-72.934,73.411m0-145.572c-39.527,0-71.684,32.371-71.684,72.161s32.158,72.161,71.684,72.161,71.685-32.371,71.685-72.161S189.02,1012.2,149.492,1012.2",
    transform: "translate(-54.852 -724.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_273",
    "data-name": "Caminho 273",
    d: "M233.728,1411.513h-.046c-33.793-2.464-41.753-19.523-42.075-20.248a.625.625,0,0,1,1.141-.508c.077.171,8.043,17.105,41.024,19.51a.625.625,0,0,1-.045,1.248",
    transform: "translate(-137.24 -996.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_274",
    "data-name": "Caminho 274",
    d: "M25.482,1556.02a.625.625,0,0,1-.568-.882l40.637-90.022a.624.624,0,0,1,1.138.514l-40.637,90.022a.624.624,0,0,1-.57.368",
    transform: "translate(-17.81 -1049.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_275",
    "data-name": "Caminho 275",
    d: "M10.4,1795.125a5.2,5.2,0,1,1-5.2-5.235,5.218,5.218,0,0,1,5.2,5.235",
    transform: "translate(0 -1282.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_276",
    "data-name": "Caminho 276",
    d: "M536.252,1556.018a.624.624,0,0,1-.57-.368l-40.636-90.022a.625.625,0,0,1,1.138-.514l40.636,90.022a.625.625,0,0,1-.568.882",
    transform: "translate(-354.642 -1049.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_277",
    "data-name": "Caminho 277",
    d: "M630.89,1795.125a5.2,5.2,0,1,0,5.2-5.235,5.218,5.218,0,0,0-5.2,5.235",
    transform: "translate(-452.008 -1282.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_278",
    "data-name": "Caminho 278",
    d: "M635.3,1799.883a5.547,5.547,0,1,1,5.513-5.547,5.536,5.536,0,0,1-5.513,5.547m0-10.469a4.923,4.923,0,1,0,4.888,4.922,4.911,4.911,0,0,0-4.888-4.922",
    transform: "translate(-451.219 -1281.597)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_279",
    "data-name": "Caminho 279",
    d: "M1169.841,1377.176a.624.624,0,0,1-.568-.364l-73.525-160.8a.625.625,0,1,1,1.136-.52l73.524,160.8a.624.624,0,0,1-.567.884",
    transform: "translate(-785.02 -870.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_280",
    "data-name": "Caminho 280",
    d: "M1347.583,1795.125a5.2,5.2,0,1,0,5.2-5.235,5.217,5.217,0,0,0-5.2,5.235",
    transform: "translate(-965.49 -1282.386)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_36",
    "data-name": "Ret\\xE2ngulo 36",
    width: 151.986,
    height: 7.994,
    transform: "translate(173.89 337.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_281",
    "data-name": "Caminho 281",
    d: "M763.69,1196.719H611.7a.624.624,0,0,1-.625-.625V1188.1a.624.624,0,0,1,.625-.625H763.69a.624.624,0,0,1,.625.625v7.994a.624.624,0,0,1-.625.625m-151.361-1.249H763.065v-6.745H612.329Z",
    transform: "translate(-437.815 -850.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_282",
    "data-name": "Caminho 282",
    d: "M282.578,672.1c-4.2-5.7-11.715-5.537-18-4.447-7.338,1.271-14.288,4.089-21.534,5.745a43.8,43.8,0,0,1-10.454,1.216,43.127,43.127,0,0,1-9.454-1.283c-6.321-1.533-12.3-4.2-18.2-6.895a164.014,164.014,0,0,0-18.059-7.523,48.844,48.844,0,0,0-20.2-2.294c-13.994,1.505-28.129,9.069-35.764,21.2a42.419,42.419,0,0,0-3.095,39.039,42.857,42.857,0,0,0,11.806,15.953,67.782,67.782,0,0,0,18.872,10.719,92.531,92.531,0,0,0,42.567,5.987,90.372,90.372,0,0,0,38.372-12.724,93.521,93.521,0,0,0,28.114-26.366q2.323-3.333,4.332-6.871c5.146-4.31,10.359-9.342,12.592-15.846,1.73-5.041,1.337-11.238-1.889-15.61",
    transform: "translate(-89.165 -470.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_283",
    "data-name": "Caminho 283",
    d: "M487.65,832.112l11.584-14.885c.814-1.047,7.02-3.236,7.988-2.333l5.85,11.871a2.286,2.286,0,0,1,.315,2.976l-8.518,12.238a6.809,6.809,0,0,1-6.427,2.883c-3.188-.4-15.159-7.247-15.159-7.247s3.077-3.845,4.367-5.5",
    transform: "translate(-346.253 -583.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_284",
    "data-name": "Caminho 284",
    d: "M488.048,837.827a.624.624,0,0,1-.487-1.015l15.244-19.04a.624.624,0,1,1,.974.781l-15.244,19.04a.623.623,0,0,1-.488.234",
    transform: "translate(-349.22 -585.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_285",
    "data-name": "Caminho 285",
    d: "M553.729,877.133a.624.624,0,0,1-.506-.99l10.919-15.131a.624.624,0,1,1,1.013.731l-10.919,15.131a.624.624,0,0,1-.507.259",
    transform: "translate(-396.278 -616.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_286",
    "data-name": "Caminho 286",
    d: "M544.749,782.438a3.315,3.315,0,0,0-2.963-2.583,5.1,5.1,0,0,0-4.891,4.427,5.928,5.928,0,0,0,3.239,5.919,5.242,5.242,0,0,0,3.92.623,17.659,17.659,0,0,0,4.678,7.722,11.852,11.852,0,0,0,8.244,3.276c5.067-.162,9.362-4.218,11.365-8.9s2.165-9.934,2.252-15.036c0,0-7.273,5.666-17.544-1.633-1.614,4.8-4.18,7.341-8.3,6.19",
    transform: "translate(-384.63 -556.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_287",
    "data-name": "Caminho 287",
    d: "M555.087,800.873a12.541,12.541,0,0,1-8.356-3.446,18.051,18.051,0,0,1-4.673-7.456,6.123,6.123,0,0,1-3.779-.788,6.548,6.548,0,0,1-3.58-6.565,5.733,5.733,0,0,1,5.536-4.966,3.83,3.83,0,0,1,3.438,2.691c3.306.768,5.6-1.108,7.206-5.873a.624.624,0,0,1,.954-.31c9.743,6.923,16.516,1.867,16.8,1.648a.625.625,0,0,1,1.007.5c-.079,4.588-.176,10.3-2.3,15.271-2.345,5.483-7.024,9.127-11.921,9.284-.11,0-.221.005-.331.005m-12.61-12.251a.624.624,0,0,1,.595.436,17.048,17.048,0,0,0,4.506,7.45,11.218,11.218,0,0,0,7.8,3.111c5.019-.16,9.046-4.4,10.812-8.526,1.862-4.355,2.1-9.4,2.182-13.667-2.367,1.257-8.61,3.521-16.584-1.781-1.88,4.965-4.83,6.922-8.784,5.816a.624.624,0,0,1-.441-.467,2.676,2.676,0,0,0-2.38-2.094,4.5,4.5,0,0,0-4.245,3.889,5.27,5.27,0,0,0,2.9,5.273,4.594,4.594,0,0,0,3.484.579.633.633,0,0,1,.162-.021",
    transform: "translate(-383.053 -554.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_288",
    "data-name": "Caminho 288",
    d: "M551.9,806.826a.625.625,0,0,1-.592-.424,5.371,5.371,0,0,0-2.417-2.918.625.625,0,0,1,.614-1.088,6.638,6.638,0,0,1,2.987,3.6.625.625,0,0,1-.39.792.634.634,0,0,1-.2.034",
    transform: "translate(-393.032 -574.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_289",
    "data-name": "Caminho 289",
    d: "M653.279,773.831a.624.624,0,0,1-.28-1.183,8.927,8.927,0,0,0,3.369-2.94.624.624,0,1,1,1.031.7,10.175,10.175,0,0,1-3.841,3.353.621.621,0,0,1-.279.066",
    transform: "translate(-467.6 -551.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_290",
    "data-name": "Caminho 290",
    d: "M408.28,1527.426l-37.234,67.34a9.9,9.9,0,0,0,8.6,14.721h106.68a2.51,2.51,0,0,0,1.621-4.412l-30.139-26,31.018-55.6Z",
    transform: "translate(-264.94 -1091.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_291",
    "data-name": "Caminho 291",
    d: "M484.742,1608.532H378.063a10.361,10.361,0,0,1-9-5.155,10.484,10.484,0,0,1-.146-10.494l37.234-67.339a.625.625,0,0,1,.516-.322l80.544-3.947a.637.637,0,0,1,.561.295.623.623,0,0,1,.014.634l-30.77,55.154,29.753,25.664a3.134,3.134,0,0,1-2.029,5.509m-77.665-82.079-37.066,67.035a9.246,9.246,0,0,0,.129,9.254,9.123,9.123,0,0,0,7.923,4.54h106.68a1.833,1.833,0,0,0,1.748-1.222,1.856,1.856,0,0,0-.535-2.093l-30.139-26a.624.624,0,0,1-.137-.777l30.47-54.616Z",
    transform: "translate(-263.358 -1089.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_292",
    "data-name": "Caminho 292",
    d: "M427.557,1729.307a123.442,123.442,0,0,1-28.852-3.126.625.625,0,0,1,.29-1.215c11.03,2.636,23.271,3.572,37.424,2.863,12.574-.631,25.257-2.483,37.522-4.274a.625.625,0,0,1,.18,1.236c-12.294,1.8-25.006,3.652-37.64,4.285q-4.59.231-8.925.23",
    transform: "translate(-285.313 -1234.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_293",
    "data-name": "Caminho 293",
    d: "M695.77,1504.506l42.122,80.619a20,20,0,0,0,17.713,10.768h77.9a2.334,2.334,0,0,0,1.465-4.137l-32.92-27.053-24.093-49.364Z",
    transform: "translate(-498.492 -1077.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_294",
    "data-name": "Caminho 294",
    d: "M831.927,1594.939h-77.9a20.567,20.567,0,0,1-18.266-11.1l-42.122-80.619a.625.625,0,0,1,.636-.908l82.188,10.833a.623.623,0,0,1,.479.345l24.033,49.241,32.815,26.967a2.958,2.958,0,0,1-1.861,5.245M695.3,1503.7l41.565,79.554a19.32,19.32,0,0,0,17.159,10.432h77.9a1.659,1.659,0,0,0,1.591-1.126,1.681,1.681,0,0,0-.523-1.9l-32.92-27.053a.618.618,0,0,1-.165-.209l-23.945-49.062Z",
    transform: "translate(-496.913 -1076.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_295",
    "data-name": "Caminho 295",
    d: "M840.54,1729.03a250.732,250.732,0,0,1-26.441-1.4.625.625,0,0,1,.132-1.242,249.49,249.49,0,0,0,70.255-2.51.625.625,0,0,1,.219,1.23,250.848,250.848,0,0,1-44.165,3.92",
    transform: "translate(-582.869 -1235.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296",
    "data-name": "Caminho 296",
    d: "M274.51,1324.018s76.405,22.957,153.411-10.287c0,0-19.956-37.629-36.565-65.56a57.175,57.175,0,0,0-49.128-28.028H213.605l-8.63,16.958c-9.633,18.931,2.665,41.7,23.688,43.836,26.806,2.727,51.043,4.337,70.189,3.73Z",
    transform: "translate(-144.472 -874.185)",
    fill: "#790000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_297",
    "data-name": "Caminho 297",
    d: "M730.858,1344.252a.615.615,0,0,1-.284-.069.625.625,0,0,1-.271-.841,217.278,217.278,0,0,0,16.782-43.885c2.8-10.676,5.362-24.428.238-36.115-3.422-7.8-10.225-14.678-20.8-21.016a.625.625,0,1,1,.642-1.072c10.8,6.477,17.77,13.538,21.3,21.587,5.278,12.04,2.679,26.062-.175,36.934a218.474,218.474,0,0,1-16.878,44.137.624.624,0,0,1-.556.339",
    transform: "translate(-520.309 -889.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_298",
    "data-name": "Caminho 298",
    d: "M545.14,1444.711a.625.625,0,0,1-.018-1.249l16-.472h.019a.625.625,0,0,1,.017,1.249l-16,.472h-.019",
    transform: "translate(-390.124 -1033.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299",
    "data-name": "Caminho 299",
    d: "M243.824,982.149h65.528l9.841-19.736s12.919,13.381,29.387,11.1,34.489-16.582,49.994-16.441a12.043,12.043,0,0,1,6.906,4.7c2.424,3.744,5.966,3.184,6.574.8s-3.379-9.151-3.379-9.151,2.082,3.065,4.928,8.224c2.2,3.987,4.615-.273,4.615-.273s3.733-2.479,2.67-8.5a5.462,5.462,0,0,0,.683-4.449c-.7-2.58-8.034-16.845-28.319-14.188a252.808,252.808,0,0,0-33.271,6.952,9.517,9.517,0,0,1-10.459-3.894,45.6,45.6,0,0,1-5.418-10.767c-3.69-11.154-8.277-38.553-23.888-38.569-11.763-.012-22.147,3.115-49.778,46.278-19.083,29.811-26.614,47.909-26.614,47.909",
    transform: "translate(-174.69 -636.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300",
    "data-name": "Caminho 300",
    d: "M242.245,981.2a.625.625,0,0,1-.576-.865c.075-.182,7.77-18.49,26.665-48.005,27.63-43.163,38.273-46.565,50.238-46.565h.066c13.547.014,18.98,19.554,22.575,32.484.7,2.529,1.31,4.714,1.905,6.513a44.379,44.379,0,0,0,5.345,10.616,8.888,8.888,0,0,0,9.773,3.64,255.726,255.726,0,0,1,33.357-6.97c20.046-2.623,27.977,10.882,29,14.643a6.13,6.13,0,0,1-.629,4.75c.892,5.62-2.176,8.279-2.856,8.792-.311.506-1.452,2.17-3,2.17H414.1c-1-.006-1.88-.688-2.619-2.027q-.194-.352-.384-.691a3.8,3.8,0,0,1-.013,1.472,3.112,3.112,0,0,1-2.556,2.32c-1.832.3-3.761-.8-5.148-2.937a11.4,11.4,0,0,0-6.455-4.419h-.16c-8.176,0-16.936,3.98-26.206,8.192-7.773,3.531-15.809,7.182-23.468,8.245-14.541,2.017-26.476-8.063-29.293-10.677l-9.462,18.975a.624.624,0,1,1-1.117-.557l9.841-19.736a.624.624,0,0,1,1.007-.155c.128.131,12.9,13.124,28.852,10.913,7.479-1.037,15.432-4.65,23.124-8.144,9.068-4.12,18.455-8.373,26.962-8.3a.644.644,0,0,1,.125.014,12.576,12.576,0,0,1,7.3,4.975c1.3,2.015,2.868,2.554,3.9,2.384a1.857,1.857,0,0,0,1.547-1.4c.4-1.554-1.821-6.149-3.311-8.68a.625.625,0,0,1,1.055-.668c.021.031,2.13,3.148,4.958,8.273.346.627.892,1.376,1.53,1.381h.007c.847,0,1.741-1.229,1.988-1.661a.628.628,0,0,1,.2-.211c.135-.092,3.374-2.358,2.4-7.869a.624.624,0,0,1,.113-.481,4.8,4.8,0,0,0,.582-3.912c-.907-3.324-8.673-16.218-27.635-13.733a254.436,254.436,0,0,0-33.185,6.934,10.132,10.132,0,0,1-11.145-4.148,45.623,45.623,0,0,1-5.493-10.919c-.605-1.828-1.216-4.026-1.923-6.571-3.494-12.566-8.774-31.556-21.373-31.569h-.063c-11.567,0-21.9,3.355-49.189,45.99-18.836,29.424-26.488,47.631-26.563,47.812a.624.624,0,0,1-.576.385",
    transform: "translate(-173.112 -634.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_301",
    "data-name": "Caminho 301",
    d: "M846.907,1115.552h-.031a.625.625,0,0,1-.593-.654,15.541,15.541,0,0,0-4.125-11.2.624.624,0,1,1,.909-.856,16.815,16.815,0,0,1,4.464,12.12.625.625,0,0,1-.623.594",
    transform: "translate(-603.251 -789.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_302",
    "data-name": "Caminho 302",
    d: "M852.939,1095.031a.625.625,0,0,1-.593-.429,20,20,0,0,0-5.332-8.342.625.625,0,0,1,.853-.913,21.27,21.27,0,0,1,5.667,8.864.626.626,0,0,1-.593.82",
    transform: "translate(-606.71 -777.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_303",
    "data-name": "Caminho 303",
    d: "M718.25,1083.719a.624.624,0,0,1-.61-.494l-5.054-23.623a.624.624,0,1,1,1.221-.261l5.054,23.623a.624.624,0,0,1-.611.755",
    transform: "translate(-510.53 -758.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_304",
    "data-name": "Caminho 304",
    d: "M453.558,1043.639a.622.622,0,0,1-.477-.22,88.376,88.376,0,0,1-19.446-40.841.624.624,0,1,1,1.227-.23,87.134,87.134,0,0,0,19.172,40.263.625.625,0,0,1-.476,1.029",
    transform: "translate(-310.675 -717.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_305",
    "data-name": "Caminho 305",
    d: "M1976.55,3.969a8.446,8.446,0,0,0-10.366,7.363,34.7,34.7,0,0,0-10.2,1.688,8.494,8.494,0,1,0-14.307,8.9,34.65,34.65,0,0,0-6.019,8.4,8.488,8.488,0,1,0-3.82,16.4,34.609,34.609,0,0,0,1.688,10.191,8.571,8.571,0,0,0-.911.486,8.489,8.489,0,1,0,9.816,13.807,34.66,34.66,0,0,0,8.408,6.012,8.494,8.494,0,1,0,16.414,3.814,34.715,34.715,0,0,0,10.2-1.688,8.494,8.494,0,1,0,14.307-8.9,34.642,34.642,0,0,0,6.019-8.4,8.488,8.488,0,1,0,3.82-16.4,34.593,34.593,0,0,0-1.689-10.191,8.488,8.488,0,1,0-8.905-14.293,34.661,34.661,0,0,0-8.408-6.012,8.438,8.438,0,0,0-6.048-11.176m-6.256,26.86a15.763,15.763,0,1,1-18.941,11.782,15.758,15.758,0,0,1,18.941-11.782",
    transform: "translate(-1378.646 -2.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_306",
    "data-name": "Caminho 306",
    d: "M1957.229,87.663a9.112,9.112,0,0,1-8.882-11.177c.04-.174.088-.352.146-.538a35.268,35.268,0,0,1-7.69-5.5c-.156.114-.311.217-.462.312a9.114,9.114,0,1,1-9.639-15.47c.151-.094.312-.186.484-.277a35.241,35.241,0,0,1-1.544-9.321c-.193-.031-.374-.067-.549-.107a9.112,9.112,0,1,1,4.134-17.75c.174.041.353.089.54.146a35.24,35.24,0,0,1,5.5-7.684c-.114-.157-.217-.311-.312-.462a9.118,9.118,0,0,1,15.484-9.632c.095.152.187.313.278.484a35.263,35.263,0,0,1,9.331-1.544c.031-.192.066-.374.107-.548a9.118,9.118,0,0,1,17.764,4.128c-.04.175-.089.353-.146.538a35.238,35.238,0,0,1,7.689,5.5c.159-.114.312-.218.464-.312a9.113,9.113,0,1,1,9.638,15.47c-.152.094-.312.187-.484.278a35.178,35.178,0,0,1,1.544,9.321c.193.031.375.066.548.107a9.112,9.112,0,1,1-4.133,17.75c-.176-.041-.354-.089-.54-.146A35.24,35.24,0,0,1,1991,68.912c.114.157.217.31.312.462a9.118,9.118,0,0,1-15.484,9.633c-.094-.151-.187-.312-.277-.484a35.3,35.3,0,0,1-9.332,1.544c-.031.192-.066.374-.107.548a9.135,9.135,0,0,1-8.882,7.049M1940.849,69a.626.626,0,0,1,.435.176,34.032,34.032,0,0,0,8.256,5.9.625.625,0,0,1,.3.77,7.986,7.986,0,0,0-.279.915,7.87,7.87,0,1,0,15.485,2.618.625.625,0,0,1,.612-.558,34.063,34.063,0,0,0,10.018-1.658.623.623,0,0,1,.759.33,7.87,7.87,0,1,0,13.255-8.244.625.625,0,0,1,.038-.828,34.012,34.012,0,0,0,5.911-8.249.626.626,0,0,1,.77-.3,7.831,7.831,0,0,0,10.366-5.6,7.861,7.861,0,0,0-5.882-9.439,7.936,7.936,0,0,0-.945-.154.625.625,0,0,1-.557-.612,33.931,33.931,0,0,0-1.658-10.007.625.625,0,0,1,.331-.759,7.864,7.864,0,1,0-8.251-13.24.624.624,0,0,1-.826-.039,34,34,0,0,0-8.257-5.9.625.625,0,0,1-.3-.771,7.869,7.869,0,1,0-15.206-3.532.624.624,0,0,1-.612.557,34.048,34.048,0,0,0-10.017,1.658.623.623,0,0,1-.759-.33,7.826,7.826,0,0,0-11.292-3.363,7.812,7.812,0,0,0-1.963,11.607.624.624,0,0,1-.039.827,34.025,34.025,0,0,0-5.91,8.249.624.624,0,0,1-.77.3,7.861,7.861,0,1,0-4.484,15.038,7.684,7.684,0,0,0,.945.154.625.625,0,0,1,.558.612,33.97,33.97,0,0,0,1.658,10.008.624.624,0,0,1-.33.759,7.907,7.907,0,0,0-.845.451A7.864,7.864,0,1,0,1939.68,69.7a7.9,7.9,0,0,0,.776-.559.623.623,0,0,1,.392-.138m24.286-8.011a16.388,16.388,0,1,1,15.975-12.676,16.4,16.4,0,0,1-15.975,12.676m0-31.526a15.139,15.139,0,1,0,14.756,18.567,15.151,15.151,0,0,0-14.756-18.567",
    transform: "translate(-1377.065 -1.108)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165",
    "data-name": "Grupo 165",
    transform: "translate(637.637 50.992)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164",
    "data-name": "Grupo 164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163",
    "data-name": "Grupo 163",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_307",
    "data-name": "Caminho 307",
    d: "M2275.043,179.954a4.249,4.249,0,0,0-5.107,3.16,4.368,4.368,0,0,0-.085.509,17.352,17.352,0,0,0-5.1.833,4.313,4.313,0,0,0-.242-.456,4.247,4.247,0,0,0-7.223,4.469,4.312,4.312,0,0,0,.3.42,17.31,17.31,0,0,0-3.02,4.193,4.3,4.3,0,0,0-.494-.151,4.244,4.244,0,1,0-1.435,8.347,17.323,17.323,0,0,0,.832,5.1,4.243,4.243,0,1,0,4.017,7.457,4.292,4.292,0,0,0,.42-.3,17.338,17.338,0,0,0,4.2,3.016,4.246,4.246,0,1,0,8.118,2.435,4.325,4.325,0,0,0,.084-.509,17.356,17.356,0,0,0,5.1-.833,4.315,4.315,0,0,0,.242.456,4.247,4.247,0,0,0,7.223-4.469,4.347,4.347,0,0,0-.3-.42,17.329,17.329,0,0,0,3.019-4.194,4.244,4.244,0,1,0,1.929-8.2,17.315,17.315,0,0,0-.833-5.1,4.243,4.243,0,1,0-4.016-7.457,4.193,4.193,0,0,0-.42.3,17.339,17.339,0,0,0-4.2-3.016,4.286,4.286,0,0,0,.151-.493,4.243,4.243,0,0,0-3.163-5.1m-3.159,13.423a7.882,7.882,0,1,1-9.485,5.869,7.879,7.879,0,0,1,9.485-5.869",
    transform: "translate(-2248.851 -179.841)",
    fill: "#f26f21"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_308",
    "data-name": "Caminho 308",
    d: "M1855.969,53.17h-24.092a.624.624,0,1,1,0-1.249h24.092a.624.624,0,1,1,0,1.249",
    transform: "translate(-1312.02 -37.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_309",
    "data-name": "Caminho 309",
    d: "M1828.389,86.1h-16.763a.625.625,0,1,1,0-1.249h16.763a.625.625,0,0,1,0,1.249",
    transform: "translate(-1297.511 -60.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_310",
    "data-name": "Caminho 310",
    d: "M2456.875,275.59h-24.091a.625.625,0,0,1,0-1.249h24.091a.625.625,0,1,1,0,1.249",
    transform: "translate(-1742.546 -196.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_311",
    "data-name": "Caminho 311",
    d: "M2429.294,308.521h-16.763a.625.625,0,1,1,0-1.249h16.763a.625.625,0,0,1,0,1.249",
    transform: "translate(-1728.036 -220.148)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagemLogin);
export default __webpack_public_path__ + "static/media/imagem-login.6f477fcfcb045cf3876e87edbc4b4339.svg";
export { ForwardRef as ReactComponent };